// import firebase from "firebase/app";
import "firebase/auth";
import { ThunkAction } from "redux-thunk";
import { Action } from "redux";

import {
    SET_WEEK_COUNT,
    SET_DOCUMENT_TRACK_ORDER,
    ResourcePlannerActionTypes,
    SET_SELECTED_DAY,
    IIncrementStartDatePayload,
    INCREMENT_START_DATE,
    GET_TRACK_SUBJECTS,
    GET_TRACK_ORDER,
    ISetDocumentTrackOrderActionPayload,
    GET_JOBPACKS
} from "./types";

import { selectStartDate, selectTrackOrder } from "./selectors";
import { DropResult, ResponderProvided, DragStart } from "react-beautiful-dnd";
import moment from "moment";
import firebase from "firebase/app";

const setWeekCountAction = (weekCount: number): ResourcePlannerActionTypes => {
    return {
        type: SET_WEEK_COUNT,
        payload: weekCount
    };
};

export const setWeekCount = (
    weekCount: number
): ThunkAction<void, any, null, Action<string>> => dispatch => {
    dispatch(setWeekCountAction(weekCount));
};

export const setDocumentTrackOrder = (
    payload: ISetDocumentTrackOrderActionPayload
): ResourcePlannerActionTypes => {
    return {
        type: SET_DOCUMENT_TRACK_ORDER,
        payload
    };
};

export const incrementStartDateAction = (
    payload: IIncrementStartDatePayload
): ResourcePlannerActionTypes => {
    return {
        type: INCREMENT_START_DATE,
        payload
    };
};

export const incrementStartDate = (
    increment: number
): ThunkAction<void, any, null, Action<string>> => (dispatch, getState) => {
    const state = getState();
    const startDate = selectStartDate(state);
    const newStartDate = moment(startDate).add(increment, "weeks");

    dispatch(incrementStartDateAction(newStartDate));
};

export const onDragStart = (
    result: DragStart,
    provided: ResponderProvided
): ThunkAction<void, any, null, Action<string>> => (dispatch, getState) => {
  
};

export const onDragEnd = (
    result: DropResult,
    provided: ResponderProvided
): ThunkAction<void, any, null, Action<string>> => (dispatch, getState) => {
    const state = getState();

    if (!result.destination) {
        return;
    }

    if (result.type === "tracks") {
        const trackOrder = selectTrackOrder(state);
        const newTrackOrder = Array.from(trackOrder);
        newTrackOrder.splice(result.source.index, 1);
        newTrackOrder.splice(result.destination.index, 0, result.draggableId);
        dispatch(getTrackOrderAction(newTrackOrder));
        firebase.auth().onAuthStateChanged(async user => {
            if (user !== null) {
                await firebase
                    .database()
                    .ref(`/dashboard/resource_planner/trackOrder`)
                    .set(newTrackOrder);
            }
        });
    }
};

export const setSelectedDay = (payload: number): ResourcePlannerActionTypes => {
    return {
        type: SET_SELECTED_DAY,
        payload
    };
};

const getTrackOrderAction = (payload: string[]): ResourcePlannerActionTypes => {
    return {
        type: GET_TRACK_ORDER,
        payload
    };
};

export const getTrackOrder = (): ThunkAction<
    void,
    any,
    null,
    Action<string>
> => (dispatch, getState) => {
    firebase.auth().onAuthStateChanged(user => {
        if (user !== null) {
            firebase
                .database()
                .ref("/dashboard/resource_planner/trackOrder")
                .on("value", snapshot => {
                    const subjects = snapshot.val() || [];
                    dispatch(getTrackOrderAction(subjects));
                });
        }
    });
};

export const setTrackOrder = (
    chosenTrackSubjects: Array<{ name: string; key: string }>
): ThunkAction<void, any, null, Action<string>> => (dispatch, getStore) => {
    const store = getStore();
    const documentTrackOrder = selectTrackOrder(store);
    const addedTracks = chosenTrackSubjects.map(e => e.key);
    const updatedTrackOrder = [...documentTrackOrder, ...addedTracks];
    dispatch(getTrackOrderAction(updatedTrackOrder));

    firebase.auth().onAuthStateChanged(async user => {
        if (user !== null) {
            await firebase
                .database()
                .ref(`/dashboard/resource_planner/trackOrder`)
                .set(updatedTrackOrder);
        }
    });
};

const getJobpacksAction = (payload: any): ResourcePlannerActionTypes => {
    return {
        type: GET_JOBPACKS,
        payload
    };
};

export const getJobpacks = (year ="",month=""): ThunkAction<
    void,
    any,
    null,
    Action<string>
> => dispatch => {
    firebase.auth().onAuthStateChanged(async user => {
        if (user !== null) {
            firebase
                .database()
                .ref(`/subjects/jobpacks/active/${year}/${month}/`)
                .on("value", snapshot => {
                    const subjects = snapshot.val();
                    dispatch(getJobpacksAction(subjects));
                });
        }
    });
};

const getTrackSubjectsAction = (payload: any): ResourcePlannerActionTypes => {
    return {
        type: GET_TRACK_SUBJECTS,
        payload
    };
};

export const getTrackSubjects = (): ThunkAction<
    void,
    any,
    null,
    Action<string>
> => dispatch => {
    firebase.auth().onAuthStateChanged(async user => {
        if (user !== null) {
            firebase
                .database()
                .ref(`/subjects/machines`)
                .on("value", snapshot => {
                    const subjects = snapshot.val();
                    dispatch(getTrackSubjectsAction(subjects));
                });
        }
    });
};

export const removeTrack = (
    index: number
): ThunkAction<void, any, null, Action<string>> => (dispatch, getStore) => {
    const state = getStore();
    const trackOrder = [...selectTrackOrder(state)];

    trackOrder.splice(index, 1);

    dispatch(getTrackOrderAction(trackOrder));
    firebase.auth().onAuthStateChanged(async user => {
        if (user !== null) {
            await firebase
                .database()
                .ref(`/dashboard/resource_planner/trackOrder`)
                .set(trackOrder);
        }
    });
};
